<template>
  <b-card title="اطلاعات دریافتی از اینماد">
    <!-- start skeleton -->
    <div v-if="loadedResultInquiry == null">
      <b-row>
        <b-col cols="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-form-group label="">
            <b-skeleton type="input"></b-skeleton>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <!-- end skeleton -->
    <!-- strat show api respons -->
    <div v-else>
      <form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="3">
            <b-form-group label="نوع مشتری:">
              <div class="form-control">
                {{
                  loadedResultInquiry.usertype &&
                  loadedResultInquiry.usertype === 1
                    ? "حقیقی (تبعه ایران)"
                    : loadedResultInquiry.usertype &&
                      loadedResultInquiry.usertype === 2
                    ? "حقیقی (تبعه خارجی)"
                    : null
                }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام:">
              <div class="form-control">{{ loadedResultInquiry.name }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام خانوادگی:">
              <div class="form-control">{{ loadedResultInquiry.family }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام پدر:">
              <div class="form-control">{{ loadedResultInquiry.father }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="جنسیت:">
              <div class="form-control">
                {{ loadedResultInquiry.gender === 0 ? "زن" : "مرد" }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group
              id="example-input-group-1"
              label="نام به انگلیسی:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.user.en_name.$model"
                :state="validateState('en_name')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_name.required"
                id="input-1-live-feedback"
                >وارد کردن نام انگلیسی اجباری می باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_name.enchars"
                id="input-1-live-feedback"
                >نام انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_name.minLength"
                id="input-1-live-feedback"
                >نام انگلیسی باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام خانوادگی به انگلیسی:">
              <b-form-input
                v-model="$v.user.en_family.$model"
                :state="validateState('en_family')"
                id="example-input-1"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_family.required"
                id="input-1-live-feedback"
                >وارد کردن نام خانوادگی انگلیسی اجباری می
                باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_family.enchars"
                id="input-1-live-feedback"
                >نام خانوادگی انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_family.minLength"
                id="input-1-live-feedback"
                >نام خانوادگی انگلیسی باید حداقل ۳ کاراکتر
                باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام پدر به انگلیسی:">
              <b-form-input
                v-model="$v.user.en_father.$model"
                :state="validateState('en_father')"
                id="example-input-1"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_father.required"
                id="input-1-live-feedback"
                >وارد کردن نام پدر به انگلیسی اجباری می
                باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_father.enchars"
                id="input-1-live-feedback"
                >نام پدر به انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_father.minLength"
                id="input-1-live-feedback"
                >نام پدر به انگلیسی باید حداقل ۳ کاراکتر
                باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="تاریخ تولد:">
              <div class="form-control">
                {{ loadedResultInquiry.birthdate }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="کد ملی:">
              <div class="form-control">{{ loadedResultInquiry.national }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="شماره شناسنامه:">
              <b-form-input
                id="example-input-1"
                v-model="$v.user.id_number.$model"
                :state="validateState('id_number')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.id_number.required"
                id="input-1-live-feedback"
                >شماره شناسنامه را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.id_number.numbers"
                id="input-1-live-feedback"
                >شماره شناسنامه فقط باید عدد باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.id_number.idnumbers"
                id="input-1-live-feedback"
                >شماره شناسنامه عدد 0 نباشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="موبایل کاربر(شخص حقیقی):">
              <div class="form-control">
                {{ loadedResultInquiry.mobile }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="ایمیل:">
              <div class="form-control">{{ loadedResultInquiry.email }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="تلفن کسب و کار:">
              <div class="form-control">{{ loadedResultInquiry.phone }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام استان:">
              <div class="form-control">{{ loadedResultInquiry.State }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="شهر:">
              <div class="form-control">{{ loadedResultInquiry.city }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="کد پستی کسب و کار:">
              <div class="form-control">
                {{ loadedResultInquiry.postalcode }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="9">
            <b-form-group label="آدرس کسب و کار:">
              <div class="form-control">{{ loadedResultInquiry.address }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="آدرس دامنه:">
              <div class="form-control">{{ loadedResultInquiry.domain }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="تاریخ اعطا لوگو نماد اعتماد الکترونیکی:">
              <div class="form-control">
                {{ loadedResultInquiry.approvedate }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="تاریخ انقضا لوگو نماد اعتماد الکترونیکی:">
              <div class="form-control">{{ loadedResultInquiry.expdate }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="نام فارسی کسب و کار:">
              <div class="form-control">{{ loadedResultInquiry.nameper }}</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-form-group label="کد رهگیری مالیات:">
              <div v-if="!loadedResultInquiry.TaxCode===null" class="form-control">{{ loadedResultInquiry.TaxCode }}</div>
              <div v-else>
                <b-form-input
                id="example-input-1"
                v-model="$v.user.taxpayercode.$model"
                :state="validateState('taxpayercode')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.taxpayercode.required"
                id="input-1-live-feedback"
                >کد رهگیری مالیاتی اجباری می باشد.</b-form-invalid-feedback
              >

              <b-form-invalid-feedback
                v-else-if="!$v.user.taxpayercode.numbers"
                id="input-1-live-feedback"
                >کد رهگیری مالیاتی عدد می باشد.</b-form-invalid-feedback
              >
              </div>
              
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="6">
            <b-form-group label="شماره شبا:">
              <b-form-input
                id="example-input-1"
                v-model="$v.user.iban.$model"
                :state="validateState('iban')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.iban.required"
                id="input-1-live-feedback"
                >شماره شناسنامه را وارد کنید</b-form-invalid-feedback
              >

              <b-form-invalid-feedback
                v-else-if="!$v.user.iban.iban"
                id="input-1-live-feedback"
                >فرمت شماره شبا صحیح نمی باشد.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3">
        <b-form-group label="نوع کسب و کار:">
          <b-form-select
    v-model="$v.user.mdid9_category.$model"
    :state="validateState('mdid9_category')"
      :options="Options"
    ></b-form-select>
          <b-form-invalid-feedback
                v-if="!$v.user.mdid9_category.required"
                id="input-1-live-feedback"
                >انتخاب نوع کسب و کار اجباری می باشد.</b-form-invalid-feedback
              >
        </b-form-group>
      </b-col>
        </b-row>
        <hr />
        <h6 class="pt-3 pb-3">لیستی از نوع کاال و خدمت کسب و کار</h6>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            md="3"
            v-for="service in loadedResultInquiry.services"
            :key="service.id"
          >
            <b-form-group>
              <div class="form-control">{{ service.service }}</div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <div class="form-group">
          <button class="btn btn-primary"  :class="(submitted ? 'spinner spinner-light spinner-right' : '')">Register</button>
        </div>
      </form>
    </div>
    <!-- end of show api respons -->
  </b-card>
</template>


<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import { required, minLength,  } from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import httpHelper from "../../helpers/httpHelper";

const enchars = (value, vm) => !/[^A-Za-z\s]/.test(value);
const numbers = (value, vm) => !/[^0-9]/.test(value);
const idnumbers = (value, vm) => {
  return parseInt(value) != 0;
};
const iban = (value, vm) => /^\b(I|i)(R|r)[0-9]{24}$/.test(value);

export default {
  name: "enamad",
  props:['submitted'],
  mixins: [validationMixin],
  components: {MDDropdown},
  data() {
    return {
      user: {
        email: "",
        fa_name: "",
        fa_family: "",
        fa_father: "",
        en_name: "",
        en_family: "",
        en_father: "",
        mobile: "",
        name: "",
        phone: "",
        postalCode: "",
        national_card_number: "",
        id_number: "",
        merchant_type: 0,
        pre_phone: "",
        iban: "",
        website_name: '',
        website_en_name: '',
        website: '',
        taxpayercode: '',
        pre_phone:'',
        mdid9_category:''
      },
      Options:[],
      data:[]
    };
  },
  watch: {},
  validations: {
    user: {
      mdid9_category: {
        required
      },
      en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_family: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_father: {
        enchars,
        required,
        minLength: minLength(3),
      },
      id_number: {
        required,
        numbers,
        minLength: minLength(1),
        idnumbers,
      },
      iban: {
        required,
        iban,
      },
      taxpayercode: {
        required,
        numbers,
      },
    },
  },
  computed: {
    loadedResultInquiry() {
      return this.$store.getters.loadedResultInquiry;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "اینماد " },
      { title: "اطلاعات کاربری-حقیقی" },
    ]);
    this.getBusinessType()
  },
  methods: {
    handleSubmit(e) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.user.$anyError) {
        return;
      }
      Object.assign(this.user, {
        email: this.loadedResultInquiry.email,
        fa_name: this.loadedResultInquiry.name,
        fa_family: this.loadedResultInquiry.family,
        fa_father: this.loadedResultInquiry.father,
        en_name: this.$v.user.en_name.$model,
        en_family: this.$v.user.en_family.$model,
        en_father: this.$v.user.en_father.$model,
        mobile: this.loadedResultInquiry.mobile,
        phone_support: this.loadedResultInquiry.phone,
        phone: this.loadedResultInquiry.phone,
        postalCode: this.loadedResultInquiry.postalcode,
        national_card_number: this.loadedResultInquiry.national,
        id_number: this.$v.user.id_number.$model,
        merchant_type: 0,
        pre_phone: this.loadedResultInquiry.phone.slice(0,2),
        name: this.loadedResultInquiry.fullname,
        iban: this.$v.user.iban.$model,
        mdid17_merchant_type:
          this.loadedResultInquiry.usertype === 1 ||
          this.loadedResultInquiry.usertype === 2
            ? 1550
            : 1551,
        mdid18_gender: this.loadedResultInquiry.gender === "مرد" ? 1560 : 1561,
        address: this.loadedResultInquiry.address,
        birth_date: this.loadedResultInquiry.birthdate,
        id_number: this.$v.user.id_number.$model,
        website_name: this.loadedResultInquiry.nameper,
        website_en_name: this.loadedResultInquiry.nameeng,
        website: this.loadedResultInquiry.domain,
        taxpayercode: this.loadedResultInquiry.taxcode!=null ? this.loadedResultInquiry.taxcode : this.$v.user.taxpayercode.$model, 
      });
      this.$emit("validattion", this.user);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    getBusinessType(){
      httpHelper
      .getData("enamad/get-mdid9-metadata")
      .then((res) => {
        
        this.data = res.result.map((element) => {
          return {
            parent: element.parent_id,
            value: element.id,
            text: element.title,
          };
        });
         this.Options = [];
        this.data.forEach((element) => {
          if (element.parent == this.parent) {
            this.Options.push(element);
          }
        });
      });
    }
  },
};
</script>

<style>
</style>

